module.exports = __webpack_public_path__ + "static/media/YM33_0.2b3d5cda.jpg";